import { render, staticRenderFns } from "./bank-outlets.vue?vue&type=template&id=5e605e60"
import script from "./bank-outlets.vue?vue&type=script&lang=js"
export * from "./bank-outlets.vue?vue&type=script&lang=js"
import style0 from "./bank-outlets.vue?vue&type=style&index=0&id=5e605e60&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports